import React, { useState, useEffect, useContext, useMemo } from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import Autocomplete from 'react-autocomplete';

import { useRandomID } from '../../utils';

export interface ISearchToolProps extends IBaseElementProps, Partial<Autocomplete.Props> {
	children?: any;
	url?: string;
	renderInput?: any;
	open?: any;
}

/**
 * SearchTool
 * @block
 * @requiresHooks
 */
const SearchTool: React.FC<ISearchToolProps> = withAppContext(
	({ context, renderInput, open = undefined, url = '' }) => {
		// @ts-ignore
		const { Api } = useContext(context);
		const [postsForSearch, setPostsForSearch] = useState(null);
		const [loading, setLoading] = useState(false);
		const [searchVal, setSearchVal] = useState('');

		useEffect(() => {
			setPostsForSearch(null);
			if ( searchVal ) {
				setLoading(true);
				Api.getPostsForSearch([searchVal])
					.then( postsForSearch => setPostsForSearch(postsForSearch))
					.finally( () => setLoading(false) )
			}
		}, [searchVal]);

		const autocompleteOnChange = (event: any, value: string) => {
			setSearchVal(value.toString().toLowerCase());
		};

		const autocompleteOnSelect = (
			event: any,
			returnValue: { label: string; link: string },
		) => {
			autocompleteOnChange(event, returnValue.label);
			window.location.href = returnValue.link;
		};

		const defaultSearchInput = (props) => (
			<form className="search" action={url}>
				<input
					type="text"
					className="search__input"
					placeholder="How can we help you?"
					aria-label="How can we help you?"
					name="s"
					{...props}
				/>
				<button
					className="search__btn"
					type="submit"
					aria-label="Submit search"
				>
					<Icon name="search" />
				</button>
			</form>
		);

		useEffect(() => {}, [postsForSearch]);

		return (
			<Autocomplete
				getItemValue={(item) => item.value}

				items={postsForSearch || []}
				onChange={autocompleteOnChange}
				onSelect={autocompleteOnSelect}
				renderInput={renderInput || defaultSearchInput}
				renderItem={(item, isHighlighted) => (
					<div className={cn('autocomplete-menu__item', isHighlighted && 'selected')} key={useRandomID('')}>
						<a href={item.link}>{item.value}</a>
					</div>
				)}
				renderMenu={(items, value) => (
					items.length
						? <div
							className="autocomplete-menu"
							children={items}
						/>
						: ( ( loading || ! searchVal )
							? <React.Fragment/>
							: <div className="autocomplete-menu">No results found</div>
						)
				)}
				value={searchVal}
				wrapperProps={{
					className: 'autocomplete',
					style: {},
				}}
			/>
		);
	},
);
export default SearchTool;
